import React from 'react';

import CreditAppWizard from '../../components/website/public/CreditAppWizard';

interface FinancingPageProps {
  title: string;
  body: string;
  primaryCta: string;
  secondaryCta: string;
  startApplication: string;
  wizard: any;
  fullName: string;
  phone: string;
  email: string;
  message: string;
  submit: string;
  success: string;
  submitError: string;
  language?: 'en' | 'es';
}

const FinancingPage: React.FC<FinancingPageProps> = ({ title, body, language = 'en' }) => {
  return (
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
      {/* Brief intro */}
      <div className="text-center mb-8">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">{title}</h1>
        <p className="text-lg text-gray-600">{body}</p>
      </div>

      {/* The wizard IS the page */}
      <CreditAppWizard language={language} onClose={() => window.history.back()} />
    </main>
  );
};

export default FinancingPage;
